<!-- smallReChange [ 充值相关 ] -->
<template>

    <div id='smallReChange'>

    </div>

</template>

<script>
export default {
    components: { },

    props: [],

    data() {
        return{
            cycleKey: null,
            orderidKey: null,
        }
    },

    computed: { },

    watch: {
        route: {
            handler: function(val, old){

            },
            deep: true
        }
    },

    created(){

    },

    mounted(){
        this.loadMain();

        this.getData();
    },

    methods:{
        loadMain(){
            this.cycleKey = this.$route.params.cycle;
            this.orderidKey = this.$route.params.orderid;
        },

        getData(){
            
        },

        // 查询
        search(){
            
        },

        // 重置
        resetting(){

        },

        // 导出
        downmeterStatus(){
            
        },
    },
}
</script>


// WEBPACK FOOTER //
// smallReChange.vue?b674b536